// extracted by mini-css-extract-plugin
export var SocialIcons = "y_bT";